import React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

export default function PaymentLoader() {
  const fullPageLoader = {
    position: 'fixed',
    top: 0,
    background: 'rgba(255, 255, 255, 0.85)',
    width: '100%',
    left: 0,
    height: '100%',
    zIndex: '99998',
    bottom: 0,
    right: 0
  };

  return (
    <div style={fullPageLoader}>
      <Box
        sx={{
          display: 'flex',
          flexWrap: 'wrap',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
          flexDirection: 'column',
          '& > :not(style)': {
            m: 1
          }
        }}
      >
        <Box>
          <CircularProgress />
        </Box>
        <Typography
          variant="h3"
          component="h3"
          sx={{
            fontSize: '28px',
            lineHeight: '36px',
            fontWeight: '700'
          }}
        >
          Processing Payment
        </Typography>
      </Box>
    </div>
  );
}
